// extracted by mini-css-extract-plugin
export default {"main":"aboxI","active":"cuOda","content":"wenbU","text":"kpt1Y"};